module.exports = __webpack_public_path__ + "static/img/qp.412e761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitefriends/newInvite/Slicing/qp.png
// module id = F6Cr
// module chunks = 23